import { render, staticRenderFns } from "./ReportInvoices.vue?vue&type=template&id=58d33c56&scoped=true&"
import script from "./ReportInvoices.vue?vue&type=script&lang=js&"
export * from "./ReportInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d33c56",
  null
  
)

export default component.exports